import styled from 'styled-components';

import HtmlContent from '@telialt/common-html-content/src';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const LegalTextWrapper = styled(HtmlContent)`
    font-weight: ${getPurpurTypography('weightNormal')};
    font-size: ${getPurpurTypography('scale75')};
    line-height: 1.25rem;
    color: ${getPurpurColor('gray700')};

    a {
        color: ${getPurpurColor('gray700')};

        &:hover {
            color: ${getPurpurColor('purple500')};
        }
    }
`;

export const GiftLegalTextWrapper = styled.div`
    margin-top: ${getPurpurSpacing('300')};
`;
